// src/hooks/useTenantTelemetry.js
import { useCallback, useEffect, useRef, useState } from "react";
import { subscribeTenantStream } from "../infra/WebSocketService";

export default function useTenantTelemetry() {
  const [connected, setConnected] = useState(false);
  const [devicesBySerial, setDevicesBySerial] = useState({});
  const [lastUpdated, setLastUpdated] = useState(null);
  const [reconnecting, setReconnecting] = useState(false);
  const ctrlRef = useRef(null);

  const subscribe = useCallback(() => {
    ctrlRef.current?.close();
    // Guarda contra race condition: o close() acima é assíncrono (o socket
    // antigo só dispara seu próprio onclose depois), então sem esse check
    // esse callback tardio do socket velho podia rodar DEPOIS do onOpen do
    // socket novo e sobrescrever connected=true com false — parecendo que
    // "desconecta mas não reconecta" quando na real já tinha reconectado.
    const myCtrl = subscribeTenantStream(
      (norm) => {
        if (ctrlRef.current !== myCtrl) return;
        setDevicesBySerial({ ...norm.devicesBySerial });
        setLastUpdated(new Date());
      },
      {
        onOpen: () => {
          if (ctrlRef.current !== myCtrl) return;
          setConnected(true);
          setReconnecting(false);
        },
        onClose: () => {
          if (ctrlRef.current !== myCtrl) return;
          setConnected(false);
          setLastUpdated(null);
        },
        onError: () => {
          if (ctrlRef.current !== myCtrl) return;
          setConnected(false);
          setLastUpdated(null);
        },
      }
    );
    ctrlRef.current = myCtrl;
  }, []);

  useEffect(() => {
    subscribe();
    return () => {
      try {
        ctrlRef.current?.close();
      } catch {}
    };
  }, [subscribe]);

  const reconnect = useCallback(() => {
    setReconnecting(true);
    subscribe();
  }, [subscribe]);

  return { connected, devicesBySerial, lastUpdated, reconnect, reconnecting };
}
